import {
  Avatar,
  Box,
  Button,
  Menu,
  MenuItem,
  Modal,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import LogoutTwoToneIcon from "@mui/icons-material/LogoutTwoTone";
import { useState } from "react";
import { useAuth } from "../provider/auth_provider";
import { useSearchParams } from "react-router-dom";
import Lottie from "lottie-react";
import logout_loader from "../assets/logout.json";

const Profile = () => {
  const { userDetails, handleLogout, logoutLoader } = useAuth();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const [params] = useSearchParams();
  const userInfo: string = params.get("user_info")?.replaceAll(" ", "+") || "";

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!userInfo) setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        size="medium"
        aria-controls={open ? "profile-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: "#0E0E0E",
          fontSize: "1rem !important",
          cursor: userInfo ? "auto" : "pointer",
          minWidth: "auto",
          px: 1,
        }}
      >
        <Avatar sx={{ width: 24, height: 24, bgcolor:"#0E0E0E" }}>{userDetails?.name[0]}</Avatar>
      </Button>

      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "profile-button" }}
        sx={{ zIndex: 99999 }}
      >
        <MenuItem onClick={handleLogout} sx={{ fontSize: 14 }}>
          <LogoutTwoToneIcon
            sx={{ fontSize: isSmallScreen ? 14 : 16, marginRight: "0.5rem" }}
          />
          Logout
        </MenuItem>
        <Modal
          open={logoutLoader}
          aria-labelledby="loading-modal"
          aria-describedby="loading-data"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(2px)", // optional: blur background
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              p: 4,
              borderRadius: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <Lottie
              style={{
                width: isSmallScreen ? 40 : 60,
                transform: isSmallScreen ? "scale(1.4)" : "scale(1.6)",
              }}
              animationData={logout_loader}
              loop={logoutLoader}
            ></Lottie>
          </Box>
        </Modal>
      </Menu>
    </>
  );
};

export default Profile;
